import React, { useState } from 'react';
import { useDispatch } from 'react-redux';
import { Button } from 'react-bootstrap';
import snakeCaseKeys from 'snakecase-keys';

import { sendAlert } from '../../actions/utils';
import { SimpleCenteredModal } from '../../components';
import { ModalBodyIcon } from '../../components/Shared';
import { cancelAdminInsurancePolicyRequest } from '../../requests/admin/adminInsurancePolicies';
import { cancelInsurancePolicyRequest } from '../../requests/insurancePolicies';
import { InsurancePolicyCancelForm } from './InsurancePoliciesForms';

const basicCancelParams = {
  active: false,
  cancellation: '',
  comments: ''
};

const InsurancePolicyCancelModal = ({ fromAdmin, insurancePolicy, setMoreData }) => {
  const cancelBtnText = 'Cancelar póliza';
  const [modalBody, setModalBody] = useState('');
  const [modalShow, setModalShow] = useState(false);
  const dispatch = useDispatch();

  const handleModalClose = () => setModalShow(false);

  const handleSuccessRequest = () => {
    dispatch(sendAlert({ kind: 'success', message: 'Póliza cancelada con éxito' }));
    setMoreData(m => !m);
    setModalShow(false);
  };

  const handleCancelInsurancePolicyRequest = params => {
    const { cancellation, comments } = params.insurancePolicy;
    const mergedComments = `${insurancePolicy.comments}\n${comments}`;
    const sendParams = { ...snakeCaseKeys(params.insurancePolicy), cancellation, comments: mergedComments };

    if (fromAdmin) {
      cancelAdminInsurancePolicyRequest(insurancePolicy.id, {
        dispatch,
        params: { insurance_policy: sendParams },
        formData: true,
        successCallback: handleSuccessRequest
      });
    } else {
      cancelInsurancePolicyRequest(insurancePolicy.id, {
        dispatch,
        params: { insurance_policy: sendParams },
        formData: true,
        successCallback: handleSuccessRequest
      });
    }
  };

  const handleModalBody = () => {
    setModalShow(true);
    setModalBody(
      <ModalBodyIcon
        icon="close-o"
        iconVariant="danger"
        highlightedText="Cancelar una póliza"
        highlightedVariant="light-danger"
        formContent={
          <InsurancePolicyCancelForm
            insurancePolicy={basicCancelParams}
            formRequest={handleCancelInsurancePolicyRequest}
            handleModalClose={handleModalClose}
          />
        }
        submitVariant="strong-danger"
      />
    );
  };

  return (
    <>
      <div className="d-flex justify-content-end mt-5">
        <Button variant="strong-danger" className="mobile-w-100" onClick={handleModalBody}>
          {cancelBtnText}
        </Button>
      </div>

      <SimpleCenteredModal show={modalShow} body={modalBody} onHide={handleModalClose} />
    </>
  );
};

export default InsurancePolicyCancelModal;
